<template>
  <div class="aftersales">
    <div class="box">
      <div class="header">
        <div class="title">售后支持</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="list">
          <div class="box">
            <div class="item" v-for="item in aftersalesList" :key="item.id">
              <div class="item-box">
                <div class="title">
                  <img :src="item.logo" alt="" />
                  <div>{{ item.title }}</div>
                </div>
                <div class="text">
                  {{ item.text }}
                </div>
                <div class="item-list">
                  <div
                    class="item-item"
                    v-for="(it, idx) in item.list"
                    :key="idx"
                  >
                    <img :src="mobileyesLogo" alt="" />
                    <div>{{ it }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileaftersalesLogo1 from "../../../assets/product/mobileaftersalesLogo1.png";
import mobileaftersalesLogo2 from "../../../assets/product/mobileaftersalesLogo2.png";
import mobileaftersalesLogo3 from "../../../assets/product/mobileaftersalesLogo3.png";
import mobileaftersalesLogo4 from "../../../assets/product/mobileaftersalesLogo4.png";

import mobileyesLogo from "../../../assets/product/mobileyesLogo.png";

export default {
  setup() {
    return reactive({
      mobileyesLogo: mobileyesLogo,
      aftersalesList: [
        {
          id: 1,
          title: "呼叫中心",
          logo: mobileaftersalesLogo1,
          text: "您可以拨打公司全国统一售后服务热线021-021-021，向呼叫中心客服人员实时咨询各种产品问题。",
          list: ["1v1人工服务", "24小时在线", "立刻响应"],
        },
        {
          id: 2,
          title: "线上咨询",
          logo: mobileaftersalesLogo2,
          text: "您可以通过畅月数字家园的官方QQ或者官方客服随时进行咨询，帮您解决各种常见问题。",
          list: ["1v1人工服务", "24小时在线", "3分钟响应"],
        },
        {
          id: 3,
          title: "售后培训",
          logo: mobileaftersalesLogo3,
          text: "我们会通过手机、电脑给物业远程开展培训及问题指导处理；也会在网络上开展相关业务培训，物业所有人员均可远程参与；根据用户需求，公司可派专业工程师到现场提供技术支持。",
          list: ["专业工程师团队", "耐心认真", "线上线下"],
        },
        {
          id: 4,
          title: "免费升级",
          logo: mobileaftersalesLogo4,
          text: "随着社会的发展，我们的产品会一直不断的迭代、更新、升级，而您在使用期间可以免费享受这项服务。",
          list: ["紧跟时代", "一直更新", "免费享受"],
        },
      ],
    });
  },
};
</script>

<style scoped>
.aftersales {
  width: 100%;
  margin-top: 24px;
}

.box {
  width: 100%;
  margin: 0 auto;
  padding: 16px 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body .list {
  width: 100%;
  margin: 16px auto 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  background-image: url(../../../assets/product/mobileaftersalesBack.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.body .list .box {
  padding: 14px;
}
.body .list .item {
  width: 92vw;
  background-color: #fff;
  margin: 8px auto;
}
.body .list .item .item-box {
  padding: 12px;
}
.body .list .item .item-box .title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.body .list .item .item-box .title img {
  width: 24px;
  margin-right: 8px;
}
.body .list .item .item-box .title div {
  font-size: 14px;
  color: #333;
}
.body .list .item .item-box .text {
  font-size: 11px;
  margin-top: 6px;
  color: #6f8398;
}
.body .list .item .item-box .item-list {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.body .list .item .item-box .item-list .item-item {
  display: flex;
  align-items: center;
}
.body .list .item .item-box .item-list .item-item img {
  width: 10px;
  margin-right: 6px;
}
.body .list .item .item-box .item-list .item-item div {
  font-size: 12px;
  color: #333;
  font-weight: 600;
}
</style>
